const sleepUntil = async (f, timeoutMs) => {
  return new Promise((resolve, reject) => {
    const timeWas = new Date();
    const wait = setInterval(function () {
      if (f()) {
        console.log("resolved after", new Date() - timeWas, "ms");
        clearInterval(wait);
        resolve();
      } else if (new Date() - timeWas > timeoutMs) { // Timeout
        console.log("rejected after", new Date() - timeWas, "ms");
        clearInterval(wait);
        reject();
      }
    }, 20);
  });
}

const wishlistResultsContainer = document.querySelector('[data-wishlist-results]');

async function fetchWishlistItems() {
  const response = WishlistKing.toolkit.collection.items[0].products;

  const wishlistItem = await Promise.all(response
    .map(item => fetch(`/products/${item.handle}?view=item`)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.text();
        }

        throw new Error(
          `Could not fetch products. Server responded with: ${response.status}`
        );
      })
      .catch(error => {
        console.log(error)
        return ''
      })
    )
  );

  wishlistResultsContainer.innerHTML = wishlistItem.join('');
  const wishlistBtns = document.querySelectorAll('[data-wishlist-btn]');
  wishlistBtns.forEach(wishlistBtn => {
    wishlistBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const productId = wishlistBtn.dataset.wishlistBtn;
      WishlistKing.toolkit.removeProduct(productId).then(() => {
        fetchWishlistItems();
      });
    });
  });
}

sleepUntil(() => window.WishlistKing, 5000)
  .then(() => {
    fetchWishlistItems();
  }).catch(() => {
    console.log("WishlistKing not found")
  });